import axios from "axios";

const REMOTE_BACKEND = process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, "");
const API_BASE = process.env.NODE_ENV === "development" && REMOTE_BACKEND
  ? `${REMOTE_BACKEND}/api`
  : "/api";

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const BRL = (v) =>
  Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const waLink = (number, cargo) => {
  const digits = String(number || "").replace(/\D/g, "");
  const text = encodeURIComponent(
    `Olá! Tenho interesse na vaga de ${cargo || "emprego"} anunciada no Vagas Campinas e Região.`
  );
  return `https://wa.me/${digits}?text=${text}`;
};
